import React, { useState } from "react";
import { toast } from "sonner";
import { Award } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export const InviteAmbassadorButton = ({ u, onDone }) => {
  const [busy, setBusy] = useState(false);
  const member = u.ambassador_status && !["rejected", "withdrawn"].includes(u.ambassador_status);
  if (member) return <span className="chip inline-flex items-center gap-1 text-xs bg-emerald-50 capitalize" data-testid={`ambassador-state-${u.id}`}><Award size={12}/> Ambassador · {u.ambassador_status}</span>;
  const invited = u.ambassador_invited_at;
  const invite = async () => {
    if (!window.confirm(invited ? `${u.name} was already invited on ${invited.slice(0, 10)}. Send the invitation again?` : `Send an Ambassador invitation email to ${u.email}?`)) return;
    setBusy(true);
    try { await api.post(`/admin/ambassadors/invite/${u.id}`); toast.success(`Ambassador invitation sent to ${u.email}`); onDone?.(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <button onClick={invite} disabled={busy} className={`chip inline-flex items-center gap-1 text-xs disabled:opacity-50 ${invited ? "text-zinc-500" : "text-[var(--gold-deep)]"}`} data-testid={`invite-ambassador-${u.id}`}>
      <Award size={12}/> {busy ? "Sending…" : invited ? `Invited ${invited.slice(5, 10).split("-").reverse().join("/")}` : "Invite as Ambassador"}
    </button>
  );
};
